export default "__VITE_ASSET__BwO0jtw1__"